<template>
  <div class="common-page driver-performance-report">
    <div class="tab-box">
      <custom-tab-box :tabData="tabData" :selectTab="selectTab" @change="handleChangeTab"></custom-tab-box>
    </div>
    <div class="tab-content">
      <dateTemplate v-if="selectTab === 1"></dateTemplate>
      <weekTemplate v-if="selectTab === 2"></weekTemplate>
    </div>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
import dateTemplate from "./date/index.vue";
import weekTemplate from "./week/index.vue";
export default {
  name: "DriverPerformanceReport",
  components: {
    CustomTabBox,
    OperateBox,
    dateTemplate,
    weekTemplate,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "司机业绩报表",
        },
        {
          label: 2,
          value: "司机出勤率",
        },
      ]
    };
  },
  mounted() {},
  methods: {
    handleChangeTab(val) {
      this.selectTab = val;
    }
  },
};
</script>
<style lang="scss" scoped>
.driver-performance-report {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 0 0 16px;
  .tab-box{
    flex-shrink: 0;
  }
  .tab-content{
    flex: 1;
    overflow: hidden;
  }
}
</style>
